import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

import { screenType } from '../../constants/enum';

import type { ActionCodeSettings } from 'firebase/auth';

export const redirectUrl = (type: number, email: string): string => {
  const params = `?email=${email}?`;

  if (type === screenType.client) {
    return (
      `${window.location.protocol}//${window.location.host}/main/client/auth/basic` +
      `${params}`
    );
  } else if (type === screenType.agent) {
    return (
      `${window.location.protocol}//${window.location.host}/main/agent/auth/basic` +
      `${params}`
    );
  } else if (type === screenType.staff) {
    return (
      `${window.location.protocol}//${window.location.host}/main/auth/invite/register` +
      `${params}`
    );
  }
  return (
    `${window.location.protocol}//${window.location.host}/main/publisher/auth/basic` +
    `${params}`
  );
};

export const actionCodeSettings = (
  type: number,
  email: string
): ActionCodeSettings => {
  const url: string = redirectUrl(type, email);
  return {
    handleCodeInApp: true,
    url
  };
};

export const passwordResetSettings = (): ActionCodeSettings => ({
  handleCodeInApp: true,
  url: `${window.location.protocol}//${window.location.host}/main/auth/login`
});

export const passwordSendSettings = (): ActionCodeSettings => ({
  handleCodeInApp: true,
  url: `${window.location.protocol}//${window.location.host}/main/auth/password_change`
});

const firebaseConfig = {
  apiKey: process.env.REACT_APP_GCP_API_KEY,
  appId: process.env.REACT_APP_GCP_APPID,
  authDomain: process.env.REACT_APP_GCP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_GCP_DATABASE_URL,
  measurementId: process.env.REACT_APP_GCP_MEASUREMENT_ID,
  messagingSenderId: process.env.REACT_APP_GCP_MESSAGING_SENDER_ID,
  projectId: process.env.REACT_APP_GCP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_GCP_STORAGE_BUCKET
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

export const db = getFirestore(app);

export const functions = getFunctions(app);
